<template>
  <el-main :style="{height:height+'px'}" v-infinite-scroll="load" style="overflow:auto" :infinite-scroll-disabled="disabled">
    <div class="Scroll_content" >
      <div >

      
        <div class="titleinder_content">
            <div class="simkeropl">{{$t('Monthly.Monthlys')}}
                <div class="left_right_rili">
                    <el-date-picker
                    v-model="value2"
                    type="month"
                    value-format="yyyy-MM" 
                    :placeholder="$t('Monthly.yue')"
                    @change="get_time">
                    </el-date-picker>
                </div>
            </div>
        </div>
        <el-table
        :data="tableData"
        :cell-style="{ textAlign: 'center' }"
        :header-cell-style="{textAlign: 'center'}"
        style="width: 100%">
        <el-table-column
            prop="datetime"
            :label="$t('Monthly.Date')"
            width="190">
        </el-table-column>
        <el-table-column
            prop="student"
            :label="$t('Monthly.studen')"
            width="100">
        </el-table-column>
        <el-table-column
            prop="class"
            :label="$t('Monthly.class')"
            width="180">
        </el-table-column>
        <el-table-column
            prop="class_type"
            :label="$t('Monthly.Class_size')"
            width="100">
        </el-table-column>
        <el-table-column
            prop="credit"
            :label="$t('Monthly.Credit')">
        </el-table-column>
        <el-table-column
            prop="requried_credit"
            :label="$t('Monthly.Requried')">
        </el-table-column>
        <el-table-column
            prop="status"
            :label="$t('Monthly.Status')">
        </el-table-column>
        </el-table>
        </div>
    </div>
    <div class="mg_tinmqx" v-if="is_show"> {{$t('reached')}}</div>
  </el-main>
    
</template>
<script>
  import { setStore, getStore, keys } from '@/store';
  import IndexHeader from '../views/header'
  import IndexFooter from '../views/footer'
  import MyScheduled from '../views/scheduled'
  import MyCourse from '../views/course'
  import PastLesson from '../views/lesson'

  //引入header组件
  import Header from '../header/header'

  export default {
    components: {
      IndexHeader,
      IndexFooter,
      MyScheduled,
      PastLesson,
      MyCourse,
      Header
    },
    data () {
      return {
        height:100,
        tableData: [],
        value2:'',
        totle:null,
        pagesize:10,
        page:1,
        month:'',
        student_sn:'',
        disabled:false,
        currentPage:1,
        is_show:false,
      }
    },
    created () {
      let height = document.body.offsetHeight-80;
      this.height = height
      if (getStore(keys.token)) {
        if (getStore(keys.userInfo).status == 0) {
          this.$router.push({
            path: '/sinadd'
          })
        }
      } else {
        this.$router.push({
          path: '/'
        })
        return false
      }


      // this.get_all();
    },
    computed:{

    },
    methods: {
      /**
       * 下拉滚动方法
       */
      load(){
        if(this.value2 == ''){
          let date = new Date();
          let y = date.getFullYear();
          let m = date.getMonth() + 1;
          this.value2 = y+'-'+m;
        }
        let _this = this;
        let un = getStore(keys.userInfo);
        this.$http.get('/api/getStudentLessonLog?pagesize='+this.pagesize+'&page='+this.page+'&month='+this.month+'&student_sn='+un.last_student_sn).then((res) => {
          if (res.data.code == 200) {
            this.page = this.page+1
            if(_this.tableData.length != res.data.data.total){
              for(let i=0;i<res.data.data.data_info.length;i++){
                this.tableData.push(res.data.data.data_info[i])
              }
            }else{
              _this.is_show = true
              _this.disabled = true
            }
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      },

      get_time(val){
        this.page = 1
        this.month = val
        this.disabled = false
        this.is_show = false
        let un = getStore(keys.userInfo);
        this.$http.get('/api/getStudentLessonLog?pagesize='+this.pagesize+'&page='+this.page+'&month='+this.month+'&student_sn='+un.last_student_sn).then((res) => {
          if (res.data.code == 200) {
            this.tableData = res.data.data.data_info
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      }
    },
    mounted () {

    },
    watch: {

    },
  }
</script>
<style lang="less" scoped>

.simkeropl{
    font-family: Sofia Pro;
    font-style: normal;
    font-weight: bold;
    font-size: 33px;
    color: #000000;
    margin-bottom:30px;
    // text-align: center;
}
.titleinder_content{
    width:100%;
    // height:50px;
    border:0px solid red;
    overflow: hidden;
}
.left_right_rili{
    float: right;
}
.mg_tinmqx{
  margin-top: 40px;
  margin-bottom:40px;
  // font-family: Sofia Pro;
  // font-style: normal;
  // font-weight: 600;
  font-size: 18px;
  line-height: 27px;
  /* identical to box height */
  color: #A5A5A5;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/children/MonthyuStatement.vue